module.exports = {
  postImage: function (body) {
    return this.client.post('/api/0.1/image/', body)
  },
}
